import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  return text ? (
    <div className={css.sectionText}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        About this space
      </Heading>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>
        {richText(text, {
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
          longWordClass: css.longWord,
        })}
      </p>
    </div>
  ) : null;
};

export default SectionTextMaybe;
